import ReactiveApi from '../../apis/Reactive'
import Vuex from 'vuex';

export default {

    namespaced: true,

    state:{
        office_name: null,              
        sede_name: null,
        company_name: null,
        inventories: [],
        categorias: [],
        marcas: [],
        unidadMedidas: [],
        categoria_id: null,
        marca_id: null,
        unidadMedida_id: null,
        tipoProductos: ["MATERIAL", "REACTIVO"],
        tipoProducto: null,
        paginated:{}
    },
    
    mutations: {
        set_office_name(state, value) {
            state.office_name = value
        },
        set_sede_name(state, value) {
            state.sede_name = value
        },
        set_company_name(state, value) {
            state.company_name = value
        },
        set_inventories(state, value) {
            state.inventories = value
        },
        set_categoria(state, categoria) {
            state.categorias = categoria;
          },
          set_marca(state, marca) {
            state.marcas = marca;
          },
          set_unidadMedida(state, unidadMedida) {
            state.unidadMedidas = unidadMedida;
          },
          set_categoria_id(state, categoria_id) {
            state.categoria_id = categoria_id;
          },
          set_marca_id(state, marca_id) {
            state.marca_id = marca_id;
        },
        set_unidadMedida_id(state, unidadMedida_id) {
            state.unidadMedida_id = unidadMedida_id;
        },
        set_tipoProducto(state, tipoProducto) {
            state.tipoProducto = tipoProducto;
        },
        set_get_invetories(state, data){
            state.office_name = data.set_office_name
            state.sede_name = data.set_sede_name
            state.company_name = data.set_company_name
            state.inventories = data.set_inventories
        },
        set_paginated (state, data) {
          state.paginated =  data
        }
    },
    actions: {
        async getReactiveAll ({commit, dispatch}, filters){
            return await ReactiveApi.get_allPaginated(filters)
                .then( response => {
                  const dataAux = response.data
                  commit('set_paginated', {
                    ...dataAux.inventory
                  })
        
                  const data = {
                    set_office_name: dataAux.office_name,
                    set_sede_name: dataAux.sede_name,
                    set_company_name: dataAux.company_name,
                    set_inventories: dataAux.inventory.data
                  }

                  commit('set_get_invetories', data)

                    // console.log(response)
                    // commit('set_office_name', response.data.office_name)
                    // commit('set_sede_name', response.data.sede_name)
                    // commit('set_company_name', response.data.company_name)
                    // commit('set_inventories', response.data.inventory)
                })
                .catch( error => {
                  if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al listar inventario, vuelva a intentarlo.'
                    }, {root: true});
                })
        },

        async store({ dispatch }, reactive) {
            return await ReactiveApi.store(reactive)
              .then((response) => {
                dispatch(
                  "notifications/store_notification",
                  {
                    type: "success",
                    message: "La creacion se realizó de forma correcta",
                  },
                  { root: true }
                );
                dispatch("getReactiveAll");
              })
              .catch((error) => {
                if (error.response?.status === 401) return null
                dispatch(
                  "notifications/store_notification",
                  {
                    type: "error",
                    message: "Ocurrió un error al actualizar, vuelva a intentarlo.",
                  },
                  { root: true }
                );
              });
          },
          async update({ dispatch }, reactive) {
            return await ReactiveApi.update(reactive)
              .then((response) => {
                dispatch(
                  "notifications/store_notification",
                  {
                    type: "success",
                    message: "La actualización se realizó de forma correcta",
                  },
                  { root: true }
                );
                dispatch("getReactiveAll");
              })
              .catch((error) => {
                if (error.response?.status === 401) return null
                dispatch(
                  "notifications/store_notification",
                  {
                    type: "error",
                    message: "Ocurrió un error al actualizar, vuelva a intentarlo.",
                  },
                  { root: true }
                );
              });
          },
          async change_status({dispatch}, reactive) {
              let action = (reactive.active) ? 'inactivación' : 'activación';
              return await ReactiveApi.change_status(reactive)
                              .then( response => {
                                  dispatch('notifications/store_notification', {
                                      type: 'success',
                                      message: 'La ' + action + ' se relizó de forma correcta.'
                                  }, {root: true});
                                  dispatch('getReactiveAll')
                              })
                              .catch( error => {
                                if (error.response?.status === 401) return null
                                  dispatch('notifications/store_notification', {
                                      type: 'error',
                                      message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                                  }, {root: true});
                              })
          },
          async delete({dispatch}, reactive) {
              return await ReactiveApi.delete(reactive)
                              .then( response => {
                                  dispatch('notifications/store_notification', {
                                      type: 'success',
                                      message: 'La eliminación se realizó de forma correcta.'
                                  }, {root: true});
                                  dispatch('getReactiveAll')
                              })
                              .catch( error => {
                                if (error.response?.status === 401) return null
                                  dispatch('notifications/store_notification', {
                                      type: 'error',
                                      message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                                  }, {root: true});
                              })
          },
        async getCategoria({ commit, dispatch }, filters) {
            return await ReactiveApi.get_all_categoria(filters)
              .then((response) => {
                commit("set_categoria", response.data);
              })
              .catch((error) => {
                if (error.response?.status === 401) return null
                dispatch(
                  "notifications/store_notification",
                  {
                    type: "error",
                    message:
                      "Ocurrió un error al listar categorias, vuelva a intentarlo.",
                  },
                  { root: true }
                );
              });
          },

          async getMarca({ commit, dispatch }, filters) {
            return await ReactiveApi.get_all_marca(filters)
              .then((response) => {
                commit("set_marca", response.data);
              })
              .catch((error) => {
                if (error.response?.status === 401) return null
                dispatch(
                  "notifications/store_notification",
                  {
                    type: "error",
                    message:
                      "Ocurrió un error al listar marcas, vuelva a intentarlo.",
                  },
                  { root: true }
                );
              });
          },

          async getUnidadMedida({ commit, dispatch }, filters) {
            return await ReactiveApi.get_all_unidadMedida(filters)
              .then((response) => {
                commit("set_unidadMedida", response.data);
              })
              .catch((error) => {
                if (error.response?.status === 401) return null
                dispatch(
                  "notifications/store_notification",
                  {
                    type: "error",
                    message:
                      "Ocurrió un error al listar unidad medidas, vuelva a intentarlo.",
                  },
                  { root: true }
                );
              });
          },
    }
}